import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezonePlugin from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezonePlugin);

export const getStartAndEndTime = (
  selectedDate: string | undefined,
  view: string,
  timezone?: string
) => {
  const period =
    view === "timeGridWeek"
      ? "week"
      : view === "dayGridMonth"
      ? "month"
      : "day";

  const baseDate = timezone
    ? selectedDate
      ? dayjs(selectedDate).tz(timezone, true)
      : dayjs().tz(timezone)
    : selectedDate
    ? dayjs(selectedDate)
    : dayjs();

  return {
    gte: baseDate.startOf(period).format(),
    lte: baseDate.endOf(period).format()
  };
};

export const getZonedDate = (
  dateString: string | number,
  timezone?: string | null
) => {
  const date = new Date(dateString);

  if (timezone) {
    return new Date(date.toLocaleString("en-US", { timeZone: timezone }));
  }

  return date;
};

export function checkIfValidLocationOpenHours(
  value: Date | Dayjs | string | null | undefined
) {
  if (value === "" || value === null || value === undefined) return true;
  if (value instanceof Date) return true;
  if (dayjs.isDayjs(value)) return true;
  if (typeof value === "string") {
    const date = dayjs(value);
    return date.isValid();
  }

  return false;
}

export const amenitiesChoices = [
  { id: "Non_Toxic", name: "Non-toxic" },
  { id: "Waterless", name: "Waterless" },
  { id: "Natural_Nails_Only", name: "Natural Nails Only" },
  { id: "Handicap_Accessible", name: "Handicap-accessible" },
  { id: "Dog_Friendly", name: "Dog Friendly" },
  { id: "Kid_Friendly", name: "Kid Friendly" },
  { id: "Good_For_Groups", name: "Good for Groups" },
  { id: "Private_Parties", name: "Private Parties" },
  { id: "TV", name: "TV" },
  { id: "Cash_Tips_Only", name: "Cash Tips Only" },
  { id: "Free_Wifi", name: "Free Wifi" },
  { id: "Masked_Workforce", name: "Masked Workforce" },
  { id: "Woman_Owned", name: "Woman Owned" },
  { id: "Black_Owned", name: "Black Owned" },
  { id: "LGBTQ_Owned", name: "LGBTQ Owned" },
  { id: "Asian_Owned", name: "Asian Owned" },
  { id: "Veteran_Owned", name: "Veteran Owned" }
];

export const amenitiesNameHelper = {
  Non_Toxic: "Non-toxic",
  Waterless: "Waterless",
  Natural_Nails_Only: "Natural Nails Only",
  Handicap_Accessible: "Handicap-accessible",
  Dog_Friendly: "Dog Friendly",
  Kid_Friendly: "Kid Friendly",
  Good_For_Groups: "Good for Groups",
  Private_Parties: "Private Parties",
  TV: "TV",
  Cash_Tips_Only: "Cash Tips Only",
  Free_Wifi: "Free Wifi",
  Masked_Workforce: "Masked Workforce",
  Woman_Owned: "Woman Owned",
  Black_Owned: "Black Owned",
  LGBTQ_Owned: "LGBTQ Owned",
  Asian_Owned: "Asian Owned",
  Veteran_Owned: "Veteran Owned"
};

export const setFilterForAvailability = (
  selectedDate: any,
  companyId?: string
) => ({
  AND: [
    {
      location: {
        is: { company: { is: { id: companyId } } }
      },
      artists: {
        every: {
          artist: {
            is: { user: { isNot: null } }
          }
        }
      }
    },
    {
      OR: [
        {
          start_time: {
            gte:
              dayjs(selectedDate?.start)?.subtract(2, "day")?.toISOString() ||
              new Date().toISOString()
          },
          end_time: {
            lte:
              dayjs(selectedDate?.end)?.add(2, "day")?.toISOString() ||
              new Date().toISOString()
          }
        },
        {
          start_time: {
            lte:
              dayjs(selectedDate?.start)?.subtract(2, "day")?.toISOString() ||
              new Date().toISOString()
          },
          end_time: {
            gte:
              dayjs(selectedDate?.start)?.add(2, "day")?.toISOString() ||
              new Date().toISOString()
          }
        },
        {
          start_time: {
            lte:
              dayjs(selectedDate?.end)?.subtract(2, "day")?.toISOString() ||
              new Date().toISOString()
          },
          end_time: {
            gte:
              dayjs(selectedDate?.end)?.add(2, "day")?.toISOString() ||
              new Date().toISOString()
          }
        }
      ]
    }
  ]
});

export const formatCurrency = (value?: number | string) => {
  const n = Number(value ?? 0);
  const abs = Math.abs(n);
  const formatted = Number.isInteger(abs) ? `${abs}` : abs.toFixed(2);
  return `${n < 0 ? "-" : ""}$${formatted}`;
};
